import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';

export default function TitleAndDescription() {
  return (
    <Stack gap={{ xs: '8px', md: '12px' }}>
      <Text
        color="primary"
        family="secondary"
        size="2xl"
        weight="bold"
      >
        Where do we send your card?
      </Text>
      <Text
        color="secondary"
        size="md"
      >
        Let’s make sure it gets to you.
      </Text>
    </Stack>
  );
}
